






import {
  mdiAccount, mdiAccountLock, mdiAccountMultiple, mdiAccountSupervisor, mdiAlert, mdiBell, mdiBook, mdiBookmark,
  mdiCalendar, mdiCancel, mdiChartBar, mdiCheck, mdiCheckboxMarked, mdiChevronDoubleLeft, mdiChevronDoubleRight,
  mdiChevronDown, mdiChevronLeft, mdiChevronRight, mdiChevronUp, mdiClock, mdiClockCheckOutline, mdiClose, mdiCog,
  mdiCommentCheck, mdiCommentMinus, mdiContentSave, mdiDotsVertical, mdiDownload, mdiDragHorizontalVariant, mdiEmail,
  mdiEmailOpen, mdiFilterVariant, mdiFolderOpen, mdiFormatListBulleted, mdiHelp, mdiHelpCircleOutline, mdiLeadPencil,
  mdiLogout, mdiMagnify, mdiMessageReply, mdiMicrosoftWord, mdiMinus, mdiMinusBox, mdiOpenInNew, mdiPaperclip,
  mdiPlus, mdiRefresh, mdiReply, mdiSubdirectoryArrowRight, mdiViewSequential, mdiViewStream, mdiPlusCircle,
  mdiViewList, mdiPlaylistCheck
} from '@mdi/js'
import { VIcon } from 'vuetify/lib'
import { defineComponent } from '@vue/composition-api'

export default defineComponent({
  name: 'base-icon',
  components: {
    VIcon
  },
  props: {
    iconName: String
  },
  setup () {
    const iconSvg = {
      mdiAccount,
      mdiAccountLock,
      mdiAccountMultiple,
      mdiAccountSupervisor,
      mdiAlert,
      mdiBell,
      mdiBook,
      mdiBookmark,
      mdiCalendar,
      mdiCancel,
      mdiChartBar,
      mdiCheck,
      mdiCheckboxMarked,
      mdiChevronDoubleLeft,
      mdiChevronDoubleRight,
      mdiChevronDown,
      mdiChevronLeft,
      mdiChevronRight,
      mdiChevronUp,
      mdiClock,
      mdiClockCheckOutline,
      mdiClose,
      mdiCog,
      mdiCommentCheck,
      mdiCommentMinus,
      mdiContentSave,
      mdiDotsVertical,
      mdiDownload,
      mdiDragHorizontalVariant,
      mdiEmail,
      mdiEmailOpen,
      mdiFilterVariant,
      mdiFolderOpen,
      mdiFormatListBulleted,
      mdiHelp,
      mdiLeadPencil,
      mdiLogout,
      mdiMagnify,
      mdiMessageReply,
      mdiMicrosoftWord,
      mdiMinus,
      mdiMinusBox,
      mdiOpenInNew,
      mdiPaperclip,
      mdiPlaylistCheck,
      mdiPlus,
      mdiPlusCircle,
      mdiRefresh,
      mdiReply,
      mdiSubdirectoryArrowRight,
      mdiViewList,
      mdiViewSequential,
      mdiViewStream
    }

    return {
      iconSvg,
      mdiHelpCircleOutline
    }
  }
})
